module.exports = __webpack_public_path__ + "img/info.ae057821.svg";